var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * ODListableContext 는 하나의 Listable API 에 대한 상태관리를 해주는 컨텍스트이다.
 * 컨텍스트를 생성한 뒤, 반환되는 Context 와 Provider 를 이용할 수 있다.
 * Provider 의 children 컴포넌트들은 Context 를 이용하여 하나의 데이터에 대한 조회 및
 * API 호출을 수행할 수 있다.
 *
 * 대부분의 경우 기능을 래핑한 컴포넌트들 (ex: ODListablePaginationTable)을 사용하면 된다.
 */
import { produce } from 'immer';
import { findIndex } from 'lodash';
import React, { createContext, useCallback } from 'react';
export var ODListableStyle;
(function (ODListableStyle) {
    ODListableStyle[ODListableStyle["TableStyle"] = 0] = "TableStyle";
    ODListableStyle[ODListableStyle["TimelineStyle"] = 1] = "TimelineStyle";
})(ODListableStyle || (ODListableStyle = {}));
//
// Actions
//
var ODListableContextActionType;
(function (ODListableContextActionType) {
    ODListableContextActionType["TYPE_SET_LOADING"] = "ODListableContext/TYPE_SET_LOADING";
    ODListableContextActionType["TYPE_SET_LISTABLE_RESPONSE"] = "ODListableContext/TYPE_SET_LISTABLE_RESPONSE";
    ODListableContextActionType["TYPE_REFRESH"] = "ODListableContext/TYPE_REFRESH";
    ODListableContextActionType["TYPE_SET_PAGE_SIZE"] = "ODListableContext/TYPE_SET_PAGE_SIZE";
    ODListableContextActionType["TYPE_SET_PAGE"] = "ODListableContext/TYPE_SET_PAGE";
    ODListableContextActionType["TYPE_UPDATE_ITEM"] = "ODListableContext/TYPE_UPDATE_ITEM";
    ODListableContextActionType["TYPE_UPDATE_LOAD_OPTION"] = "ODListableContext/TYPE_UPDATE_LOAD_OPTION";
    ODListableContextActionType["TYPE_LOAD_MORE"] = "ODListableContext/TYPE_LOAD_MORE";
    ODListableContextActionType["TYPE_REMOVE_ITEMS"] = "ODListableContext/TYPE_REMOVE_ITEMS";
    ODListableContextActionType["TYPE_SET_LOAD_ERROR"] = "ODListableContext/TYPE_SET_LOAD_ERROR";
    ODListableContextActionType["TYPE_ADD_TO_SELECTED"] = "ODListableContext/TYPE_ADD_TO_SELECTED";
    ODListableContextActionType["TYPE_REMOVE_FROM_SELECTED"] = "ODListableContext/TYPE_REMOVE_FROM_SELECTED";
    ODListableContextActionType["TYPE_DESELECT_ALL"] = "ODListableContext/TYPE_DESELECT_ALL";
})(ODListableContextActionType || (ODListableContextActionType = {}));
var actionSetLoading = function (loading) { return ({
    type: ODListableContextActionType.TYPE_SET_LOADING,
    loading: loading,
}); };
var actionSetListableResponse = function (response) { return ({
    type: ODListableContextActionType.TYPE_SET_LISTABLE_RESPONSE,
    response: response,
}); };
var actionRefresh = function () { return ({ type: ODListableContextActionType.TYPE_REFRESH }); };
var actionSetPageSize = function (pageSize) { return ({
    type: ODListableContextActionType.TYPE_SET_PAGE_SIZE,
    pageSize: pageSize,
}); };
var actionSetPage = function (page) { return ({ type: ODListableContextActionType.TYPE_SET_PAGE, page: page }); };
var actionUpdateItem = function (item) { return ({
    type: ODListableContextActionType.TYPE_UPDATE_ITEM,
    item: item,
}); };
var actionUpdateLoadOptions = function (options) { return ({
    type: ODListableContextActionType.TYPE_UPDATE_LOAD_OPTION,
    options: options,
}); };
var actionLoadMore = function (force) {
    if (force === void 0) { force = false; }
    return ({
        type: ODListableContextActionType.TYPE_LOAD_MORE,
        force: force,
    });
};
var actionRemoveItems = function (itemKeys) { return ({
    type: ODListableContextActionType.TYPE_REMOVE_ITEMS,
    itemKeys: itemKeys,
}); };
var actionSetLoadError = function (error) { return ({
    type: ODListableContextActionType.TYPE_SET_LOAD_ERROR,
    error: error,
}); };
function actionAddToSelected(items) {
    return {
        type: ODListableContextActionType.TYPE_ADD_TO_SELECTED,
        items: items,
    };
}
function actionRemoveFromSelected(items) {
    return {
        type: ODListableContextActionType.TYPE_REMOVE_FROM_SELECTED,
        items: items,
    };
}
var actionDeselectAll = function () { return ({
    type: ODListableContextActionType.TYPE_DESELECT_ALL,
}); };
function createListableReducer(options) {
    return function (state, action) {
        return produce(state, function (draft) {
            switch (action.type) {
                case ODListableContextActionType.TYPE_SET_LOADING:
                    draft.loading = action.loading;
                    break;
                case ODListableContextActionType.TYPE_REFRESH:
                    if (state.style === ODListableStyle.TimelineStyle) {
                        draft.pageToLoad = 1;
                        draft.page = 0;
                        draft.hasMore = true;
                        draft.list = [];
                        draft.itemMap = {};
                    }
                    draft.callCount += 1;
                    break;
                case ODListableContextActionType.TYPE_SET_PAGE:
                    if (!draft.loading) {
                        draft.pageToLoad = action.page;
                        draft.callCount += 1;
                    }
                    break;
                case ODListableContextActionType.TYPE_SET_PAGE_SIZE:
                    if (!draft.loading) {
                        draft.pageToLoad = 1;
                        draft.page = 0;
                        draft.pageSize = Math.min(Math.max(action.pageSize, 5), 100);
                        draft.callCount += 1;
                        draft.hasMore = true;
                    }
                    break;
                case ODListableContextActionType.TYPE_UPDATE_LOAD_OPTION: {
                    draft.pageToLoad = 1;
                    draft.page = 0;
                    draft.hasMore = true;
                    // @ts-ignore
                    draft.loadOption = action.options;
                    if (state.style === ODListableStyle.TimelineStyle) {
                        draft.list = [];
                        draft.itemMap = {};
                    }
                    draft.callCount += 1;
                    break;
                }
                case ODListableContextActionType.TYPE_SET_LISTABLE_RESPONSE: {
                    var _a = action.response, list = _a.list, totalCount = _a.totalCount, page = _a.page, pageSize = _a.pageSize;
                    if (draft.style !== ODListableStyle.TimelineStyle || page === 1) {
                        // 타임라인 스타일에서는, 첫 번째 리퀘스트만 토탈카운트가 제대로 넘어온다.
                        draft.totalCount = totalCount;
                    }
                    draft.page = page;
                    draft.pageSize = pageSize;
                    draft.pages = Math.max(Math.ceil(totalCount / pageSize), 1);
                    draft.lastLoadErrorAt = 0;
                    if (draft.style === ODListableStyle.TableStyle) {
                        // @ts-ignore
                        draft.list = __spreadArrays(list);
                    }
                    else if (draft.style === ODListableStyle.TimelineStyle) {
                        // @ts-ignore
                        draft.list = __spreadArrays(draft.list, list);
                        if (draft.list.length === 0 || list.length < pageSize) {
                            draft.hasMore = false;
                        }
                    }
                    draft.list.forEach(function (item) {
                        var itemKey = options.keyExtractor(item);
                        draft.itemMap[itemKey] = item;
                    });
                    break;
                }
                case ODListableContextActionType.TYPE_UPDATE_ITEM: {
                    var item = action.item;
                    // const converted = Utils.convertDataWithRender(item)
                    var key_1 = options.keyExtractor(item);
                    var index = findIndex(draft.list, function (v) { return options.keyExtractor(v) === key_1; });
                    if (index >= 0) {
                        // @ts-ignore
                        draft.list.splice(index, 1, item);
                        // @ts-ignore
                        draft.itemMap[key_1] = item;
                    }
                    break;
                }
                case ODListableContextActionType.TYPE_LOAD_MORE: {
                    if ((action.force || draft.hasMore) && !draft.loading) {
                        draft.pageToLoad = draft.page + 1;
                        draft.callCount += 1;
                    }
                    break;
                }
                case ODListableContextActionType.TYPE_REMOVE_ITEMS: {
                    var removed_1 = 0;
                    draft.list = draft.list.filter(function (v) {
                        var index = action.itemKeys.indexOf(options.keyExtractor(v));
                        if (index === -1) {
                            return true;
                        }
                        removed_1 += 1;
                        return false;
                    });
                    draft.totalCount -= removed_1;
                    break;
                }
                case ODListableContextActionType.TYPE_SET_LOAD_ERROR: {
                    draft.lastLoadErrorAt = new Date().getTime();
                    break;
                }
                case ODListableContextActionType.TYPE_ADD_TO_SELECTED: {
                    action.items.forEach(function (item) {
                        if (!draft.selectedItems.find(function (v) { return options.keyExtractor(v) === options.keyExtractor(item); })) {
                            draft.selectedItems.push(item);
                        }
                    });
                    break;
                }
                case ODListableContextActionType.TYPE_REMOVE_FROM_SELECTED: {
                    action.items.forEach(function (item) {
                        var index = draft.selectedItems.findIndex(function (v) { return options.keyExtractor(v) === options.keyExtractor(item); });
                        if (index >= 0) {
                            draft.selectedItems.splice(index, 1);
                        }
                    });
                    break;
                }
                case ODListableContextActionType.TYPE_DESELECT_ALL: {
                    draft.selectedItems = [];
                    break;
                }
            }
        });
    };
}
function createInitialReducerState(options) {
    if (options === void 0) { options = {}; }
    return __assign({ callCount: 0, loading: false, list: [], itemMap: {}, pageToLoad: 1, page: 0, pages: 0, pageSize: 10, totalCount: -1, 
        // tslint:disable-next-line:no-object-literal-type-assertion
        loadOption: options.loadOption || {}, hasMore: true, style: ODListableStyle.TableStyle, lastLoadErrorAt: 0, selectedItems: [] }, options);
}
export function useODListableContext(name) {
    var Context = React.useState(function () {
        // tslint:disable-next-line:no-object-literal-type-assertion
        return createContext({});
    })[0];
    var Provider = React.useState(function () {
        function ProviderComponent(props) {
            var _this = this;
            var onDataLoaderError = props.onDataLoaderError, children = props.children, dataLoader = props.dataLoader, _a = props.pageSize, pageSize = _a === void 0 ? 10 : _a, keyExtractor = props.keyExtractor, afterKeyExtractor = props.afterKeyExtractor, devOptions = props.devOptions, _b = props.searchOnLoad, searchOnLoad = _b === void 0 ? true : _b, refreshToken = props.refreshToken, initialLoadOptions = props.initialLoadOptions, _c = props.noLoading, noLoading = _c === void 0 ? false : _c, _d = props.style, style = _d === void 0 ? ODListableStyle.TableStyle : _d;
            var _e = (devOptions || {}).simulateDelay, simulateDelay = _e === void 0 ? 0 : _e;
            var _f = React.useReducer(createListableReducer({ keyExtractor: keyExtractor }), createInitialReducerState({ pageSize: pageSize, style: style, loadOption: (initialLoadOptions || {}) })), state = _f[0], dispatch = _f[1];
            var getListable = useCallback(function (_state, doNotSetLoading) {
                if (doNotSetLoading === void 0) { doNotSetLoading = false; }
                return __awaiter(_this, void 0, void 0, function () {
                    var response, ex_1;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (_state.loading) {
                                    // tslint:disable-next-line:no-console
                                    // console.warn('Listable is already loading..')
                                    return [2 /*return*/];
                                }
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 4, 5, 6]);
                                if (!doNotSetLoading) {
                                    dispatch(actionSetLoading(true));
                                }
                                return [4 /*yield*/, dataLoader(_state.pageToLoad, _state.pageSize, ((_a = afterKeyExtractor) === null || _a === void 0 ? void 0 : _a(_state.list[_state.list.length - 1] || null, _state)) || null, _state.loadOption)];
                            case 2:
                                response = _b.sent();
                                return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, simulateDelay); })];
                            case 3:
                                _b.sent();
                                dispatch(actionSetListableResponse(response));
                                return [3 /*break*/, 6];
                            case 4:
                                ex_1 = _b.sent();
                                if (onDataLoaderError) {
                                    onDataLoaderError(ex_1);
                                }
                                dispatch(actionSetLoadError(ex_1));
                                // onNetworkError && onNetworkError(ex)
                                // tslint:disable-next-line:no-console
                                console.error(ex_1);
                                return [3 /*break*/, 6];
                            case 5:
                                if (!doNotSetLoading) {
                                    dispatch(actionSetLoading(false));
                                }
                                return [7 /*endfinally*/];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            }, [onDataLoaderError, dataLoader, simulateDelay, afterKeyExtractor]);
            var setPage = useCallback(function (page) { return dispatch(actionSetPage(page)); }, [dispatch]);
            var setPageSize = useCallback(function (_pageSize) { return dispatch(actionSetPageSize(_pageSize)); }, [dispatch]);
            var updateItem = useCallback(function (item) { return dispatch(actionUpdateItem(item)); }, [dispatch]);
            var refresh = useCallback(function () { return dispatch(actionRefresh()); }, [dispatch]);
            var updateLoadOption = useCallback(function (options) { return dispatch(actionUpdateLoadOptions(options)); }, [dispatch]);
            var reload = useCallback(function () {
                setPage(1);
                dispatch(actionRefresh());
            }, [setPage, dispatch]);
            var loadMore = useCallback(function (force) {
                if (force === void 0) { force = false; }
                dispatch(actionLoadMore(force));
            }, [dispatch]);
            var removeItems = useCallback(function (itemKeys) { return dispatch(actionRemoveItems(itemKeys)); }, [dispatch]);
            var addToSelected = useCallback(function (items) { return dispatch(actionAddToSelected(items)); }, [dispatch]);
            var removeFromSelected = useCallback(function (items) { return dispatch(actionRemoveFromSelected(items)); }, [dispatch]);
            var deselectAll = useCallback(function () { return dispatch(actionDeselectAll()); }, [dispatch]);
            React.useEffect(function () {
                if (searchOnLoad) {
                    refresh();
                }
            }, [refresh, searchOnLoad]);
            React.useEffect(function () {
                if (refreshToken) {
                    refresh();
                }
            }, [refresh, refreshToken]);
            React.useEffect(function () {
                refresh();
            }, [refresh, getListable]);
            React.useEffect(function () {
                if (state.callCount > 0) {
                    // noinspection JSIgnoredPromiseFromCall
                    getListable(state, noLoading);
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [state.callCount]);
            var context = {
                state: state,
                setPage: setPage,
                setPageSize: setPageSize,
                updateItem: updateItem,
                updateLoadOption: updateLoadOption,
                reload: reload,
                refresh: refresh,
                keyExtractor: keyExtractor,
                loadMore: loadMore,
                removeItems: removeItems,
                addToSelected: addToSelected,
                removeFromSelected: removeFromSelected,
                deselectAll: deselectAll,
            };
            return React.createElement(Context.Provider, { value: context }, children);
        }
        return ProviderComponent;
    })[0];
    return { Context: Context, Provider: Provider };
}
//# sourceMappingURL=ODListableContext.js.map